module.exports = __webpack_public_path__ + "img/edit.0d07c17d.svg";